// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__JvLwP","auth-panel":"styles_auth-panel__mM8I1","auth-panel-title":"styles_auth-panel-title__3pRFv"};